export const ChatMessageType = Object.freeze({
    TEXT:'TEXT',
    AUDIO:'AUDIO',
    VIDEO:'VIDEO',
    POLL:'POLL',
    IMAGE:'IMAGE'
})
export const ChatType = Object.freeze({
    PRIVATE:'PRIVATE',
    GROUP:'GROUP'
})

export function isMissingChatId(chatId) {
    return chatId == null || chatId === '' || chatId === 'null' || chatId === 'undefined';
}

export function isIncomingMessageForOpenChat(message, currentChat) {
    if (!message || !currentChat) {
        return false;
    }
    if (!isMissingChatId(currentChat.chatId) && message.chatId === currentChat.chatId) {
        return true;
    }
    if (isMissingChatId(currentChat.chatId)) {
        const peerId = currentChat.privateChatUserId;
        return message.receiverId === peerId || message.senderId === peerId;
    }
    return false;
}

export function shouldFetchUnreadForChat(chatId) {
    return !isMissingChatId(chatId);
}

export function ackSenderIdFromPayload(wsMessage) {
    return wsMessage?.senderId;
}